/** the set-aside categories of the current entity, filled ONCE by the review shell (read by the rule list and cards) */
export const SA_STORE: { rules: Record<string, any>; summary: Record<string, any>; cat: string | null } = { rules: {}, summary: {}, cat: null };
/** the review page keeps the rule-file id in rule_id */
export const ruleKey = (r: any) => String(r?.rule_id || r?.constraint_id || r?.id || "");
export const saOf = (id?: string) => (id ? SA_STORE.rules[id] : undefined);
